import { useContext } from 'react';
import { AmplifyApiClientContext } from '../providers/AmplifyApiClientProvider';

export function useAmplifyApiClientContext() {
  const context = useContext(AmplifyApiClientContext);
  if (!context) {
    throw new Error('This hook must be used within <AmplifyApiClientContext.Provider>');
  }
  return context;
}

export const useAmplifyApiClient = () => {
  return useAmplifyApiClientContext().client;
};
